module.exports = __webpack_public_path__ + "img/ico_share.97205c97.svg";